package one.healthium.db

internal object DatabaseFactory {
    suspend fun createDatabase(driverFactory: DriverFactory): AppDatabase {
        return AppDatabase(driverFactory.createDriver(AppDatabase.Schema))
    }
}